import comp from "./EULADetails";
export default comp;
